export const RESOURCE_TYPES = [
  { id: 'journal', label: 'Journal Article', icon: 'FileText' },
  { id: 'video', label: 'Video', icon: 'Video' },
  { id: 'audio', label: 'Audio', icon: 'Headphones' },
  { id: 'image', label: 'Image', icon: 'Image' },
  { id: 'document', label: 'Document', icon: 'File' },
  { id: 'website', label: 'Website', icon: 'Globe' },
  { id: 'course', label: 'Course', icon: 'GraduationCap' },
] as const
